<template>
  <button
    class="btn btn-primary"
    data-btn="editOrder"
    ref="modalTriggerButton"
    @click="$emit('editOrder')"
  >
    {{ $t('editOrder') }}
  </button>
</template>
<script>
export default {
  name: 'WCEditOrderButton',
  emits: ['editOrder'],
};
</script>
